module.exports = __webpack_public_path__ + "img/science-thumbnail-26022025.f7bdc962.png";